import React, {memo, useCallback} from 'react';

import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import './styles';

export const SAVINGS_GOAL_NOTE_MAX_LENGTH = 100;

export interface SavingsGoalNoteProps {
  name?: string;
  value: string;
  onChange: (value: string) => void;
}

const SavingsGoalNote = memo(
  ({name, value, onChange}: SavingsGoalNoteProps) => {
    const {t} = useTranslation();

    const handleChange = useCallback(
      (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        onChange(event.target.value.slice(0, SAVINGS_GOAL_NOTE_MAX_LENGTH));
      },
      [onChange],
    );

    return (
      <Box className="savings-goal-note">
        <Box className="savings-goal-note__box">
          <Typography
            component="label"
            htmlFor="PaymentLinkV2_savingsGoalNoteInput"
            className="savings-goal-note__label">
            {t('payment_link_v2.leave_note_title', {name})}
          </Typography>
          <textarea
            id="PaymentLinkV2_savingsGoalNoteInput"
            className="savings-goal-note__textarea"
            placeholder={t('payment_link_v2.leave_note_placeholder')}
            value={value}
            onChange={handleChange}
            maxLength={SAVINGS_GOAL_NOTE_MAX_LENGTH}
            rows={2}
          />
        </Box>
        <Typography
          component="span"
          className="savings-goal-note__counter">
          {value.length}/{SAVINGS_GOAL_NOTE_MAX_LENGTH}
        </Typography>
      </Box>
    );
  },
);

SavingsGoalNote.displayName = 'SavingsGoalNote';

export default SavingsGoalNote;
